<template>
  <div class="SectionHeader">
    <template v-if="heading === '1'">
      <slot />
      <div class="titleJa">{{ja}}</div>
    </template>
    <h2 v-if="heading === '2'">
      <span>{{ja}}</span>
    </h2>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    heading: {
      type: String,
      default: '1',
      require: false
    },
    ja: {
      type: String,
      require: false
    },
    en: {
      type: String,
      require: false
    }
  }
}
</script>

<style lang="scss" scoped>
.SectionHeader {
  padding: 30px 30px 0;
  font-weight: normal;
  img {
    width: 290px;
  }
  .titleJa {
    margin-top: -10px;
    font-size: 9px;
    color: #8D7F81;
    letter-spacing: 2px;
  }
  h2 {
    span {
      font-size: 16px;
      color: #4B4344;
      font-weight: bold;
    }
  }
}
</style>
